import { Event } from "@mui/icons-material";
import { Box, BoxProps, Tooltip, Typography, useTheme } from "@mui/material";
import { PimoReactComponent } from "@pimo/pimo-app-builder";

import { OverviewTableCell } from "../../molecules/overview-table-cell/overview-table-cell";
import { OverviewTableCellBody } from "../../molecules/overview-table-cell/overview-table-cell-body";
import { OverviewTableCellHeader } from "../../molecules/overview-table-cell/overview-table-cell-header";

export interface TableDateCellProps {
  /** cell header */
  header?: string;
  /** date value */
  date: string;
  /** custom icon */
  icon?: string;
  /** size of the icon */
  iconSize?: string;
  /** card props */
  cardProps?: BoxProps;
  /** tooltip content */
  textOnHover?: string;
  /** isHidden: not used in component but can be utilized externally to hide the cell */
  isHidden?: boolean;
}

export const TableDateCell: PimoReactComponent<TableDateCellProps> = ({
  cardProps = {},
  textOnHover,
  date,
  header,
  icon,
  iconSize,
}) => {
  const theme = useTheme();

  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "common.white",
            color: "black",
            border: "1px solid",
            borderColor: theme.palette.secondary.main,
            borderRadius: "6px",
            fontSize: "12px",
            fontWeight: 400,
            p: 1,
          },
        },
      }}
      title={textOnHover || ""}
      disableInteractive
    >
      <OverviewTableCell {...cardProps}>
        {header && (
          <OverviewTableCellHeader
            sx={{
              color: theme.palette.primary.contrastText,
            }}
          >
            {header}
          </OverviewTableCellHeader>
        )}
        <OverviewTableCellBody sx={{ height: "auto" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
              height: "1.5em",
            }}
          >
            {icon ? (
              <Box
                component="img"
                src={icon}
                sx={{ pr: 1, width: iconSize, height: iconSize }}
              />
            ) : (
              <Event
                sx={{
                  color: theme.palette.primary.light,
                  pr: 1,
                  width: iconSize || "2rem",
                  height: iconSize || "2rem",
                }}
              />
            )}
            <Typography variant="subtitle2">{date}</Typography>
          </Box>
        </OverviewTableCellBody>
      </OverviewTableCell>
    </Tooltip>
  );
};

export default TableDateCell;
